import type { Except } from '@festina-life/core'
import { useState } from 'react'

import { IconButton } from '../../actions/iconButton/IconButton'
import { useTranslate } from '../../hooks/useTranslate'
import { Dropdown } from '../../structure'
import type { RowAction } from '../types'

export const SortableTableRowActionButton = ({
  rowAction: { title, onClick, items, isLoading, iconName, disabledText },
}: {
  rowAction: Except<RowAction, 'key'>
}) => {
  const translate = useTranslate()

  const isEnabled = !!(onClick || items)
  const [isInternallyLoading, setIsInternallyLoading] = useState(false)

  const element = (
    <IconButton
      tip={
        isEnabled ? (
          title
        ) : (
          <>
            {!disabledText && (
              <>
                {title}
                <br />
              </>
            )}
            {disabledText ?? translate('genericUnavailableAction')}
          </>
        )
      }
      isLoading={isLoading || isInternallyLoading}
      disabled={!isEnabled}
      onClick={
        onClick
          ? async (e) => {
              e.stopPropagation()
              const result = onClick()
              if (result && typeof result.then === 'function') {
                try {
                  setIsInternallyLoading(true)
                  await result
                } finally {
                  setIsInternallyLoading(false)
                }
              }
            }
          : undefined
      }
      iconName={iconName}
    />
  )

  return items ? <Dropdown element={element} items={items} /> : element
}
